// eslint-disable-next-line unused-imports/no-unused-imports
import React from 'react';

import { Page } from '@adobe/aem-react-editable-components';
import PropTypes from 'prop-types';

export class ComponentContainer extends Page {
  render() {
    return this.childComponents;
  }
}

ComponentContainer.propTypes = {
  tagName: PropTypes.string,
};
